import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Nav from "./components/site/Nav";
import Hero from "./components/site/Hero";
import Services from "./components/site/Services";
import Events from "./components/site/Events";
import Gallery from "./components/site/Gallery";
import About from "./components/site/About";
import Testimonials from "./components/site/Testimonials";
import Pricing from "./components/site/Pricing";
import Inquiry from "./components/site/Inquiry";
import FAQ from "./components/site/FAQ";
import Contact from "./components/site/Contact";
import Footer from "./components/site/Footer";

const Home = () => (
    <main data-testid="home-page" className="bg-brand-cream text-brand-ink antialiased">
        <Nav />
        <Hero />
        <Services />
        <Events />
        <Gallery />
        <About />
        <Testimonials />
        <Pricing />
        <Inquiry />
        <FAQ />
        <Contact />
        <Footer />
    </main>
);

function App() {
    return (
        <div className="App">
            <Toaster position="bottom-right" richColors />
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
